// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"19":"421c7673","695":"8a8c44f8","3230":"0e9151e3","4666":"b4a93351","6257":"421c7673","6940":"d0c9d594"}[chunkId] + ".chunk.css";
};